import React from 'react'
import classNames from 'classnames'
import PropTypes from 'prop-types'
import Image from 'gatsby-image'
import Container from '../container'
import Row from '../row'
import Col from '../col'
import ArrowLink from '../arrow-link'
import lines from '../../images/diagonal-pattern-small.svg'
import styles from './text-image-cta.module.scss'
import shared from '../shared.module.scss'

const TextImageCTA = ({
  // TextImageCTA Props
  text,
  link,
  linkText,
  linkNewTab,
  linkExternal,
  linkArrowType,
  linkArrowPosition,
  image,
  imageAlt,

  // Section Props
  className,
  marginBottom,
  containerFluid,
  textColor,
  backgroundColor,
}) => (
  <section
    className={ classNames( styles.section, {
      [ shared.margin ]: marginBottom,
      [ shared.padding ]: backgroundColor,
    }, className ) }
    style={{
      color: textColor,
      backgroundColor,
    }}
  >
    <Container fluid={ containerFluid }>
      <Row align="center">
        <Col className={ styles.leftCol } span={ 12 } md={ 6 } lg={ 5 }>
          <img className={ styles.lines } src={ lines } alt="" />

          <div className={ styles.box }>
            <p className={ styles.text }>{ text }</p>

            <ArrowLink
              className={ styles.cta }
              to={ link }
              text={ linkText }
              newTab={ linkNewTab }
              external={ linkExternal }
              arrowType={ linkArrowType }
              arrowPosition={ linkArrowPosition }
            />
          </div>
        </Col>

        <Col span={ 12 } md={ 6 }>
          <Image className={ styles.image } fluid={ image } alt={ imageAlt } />
        </Col>
      </Row>
    </Container>
  </section>
)

TextImageCTA.propTypes = {
  // TextImageCTA Props
  text: PropTypes.string.isRequired,
  link: PropTypes.string.isRequired,
  linkText: PropTypes.string.isRequired,
  linkNewTab: PropTypes.bool,
  linkExternal: PropTypes.bool,
  linkArrowType: PropTypes.string,
  linkArrowPosition: PropTypes.string,
  image: PropTypes.object.isRequired,
  imageAlt: PropTypes.string,

  // Section Props
  className: PropTypes.string,
  marginBottom: PropTypes.bool,
  containerFluid: PropTypes.bool,
  textColor: PropTypes.string,
  backgroundColor: PropTypes.string,
}

TextImageCTA.defaultProps = {
  // TextImageCTA Props
  linkNewTab: false,
  linkExternal: false,
  linkArrowType: 'arrow',
  linkArrowPosition: 'end',
  imageAlt: '',

  // Section Props
  className: '',
  marginBottom: true,
  containerFluid: false,
  textColor: '',
  backgroundColor: '',
}

export default TextImageCTA
